import { createElement } from 'react';
import { Alert } from '@instructure/ui';
import { SavingModal } from '../SavingModal';
import { reloadWhenSaved } from './reloadWhenSaved';
import { writeStoredLanguage, writeStoredItemIndex } from './languageSelection';

// Reloads so Learnosity re-inits with the new language, resuming saved answers via
// state:'resume'. Autosave is throttled, so the reload waits for the last save.
// The classic runner has no state$ and reloads at once.
export const switchLanguage = ({
  lang,
  itemIndex,
  state$,
  overlayNode,
  liveRegionNode,
  storage = window.sessionStorage,
  render = window.ReactDOM.render,
  reload = () => window.location.reload(),
}) => {
  const t = window._t;

  // Stored only on reload, so a failed save leaves storage matching the selector.
  const storeAndReload = () => {
    writeStoredLanguage(storage, lang);
    writeStoredItemIndex(storage, itemIndex);
    reload();
  };

  if (!state$) {
    storeAndReload();
    return;
  }

  render(createElement(SavingModal, { title: t('Saving your answers…') }), overlayNode);
  reloadWhenSaved({
    state$,
    reload: storeAndReload,
    onError: () => render(
      createElement(
        Alert,
        {
          variant: 'error',
          margin: 'small',
          renderCloseButtonLabel: t('Close'),
          liveRegion: () => liveRegionNode,
        },
        t('We could not save your answers, so the language was not changed. Please try again.')
      ),
      overlayNode
    ),
  });
};
